<script lang="ts">
    import RewardsPoints from "@apps/rewards/components/RewardsPoints.svelte";
    import RewardsSpendingRulesReward from "@apps/rewards/components/RewardsSpendingRules/RewardsSpendingRulesReward.svelte";
    import type { RewardsTranslationNamespaces } from "@apps/rewards/constants/constants";
    import type RewardsAmountFormatter from "@apps/rewards/lib/RewardsAmountFormatter/RewardsAmountFormatter";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import type { RewardsSpendingRulesEntity } from "@apps/rewards/modules/SpendingRules/models/RewardsSpendingRulesEntities";
    import type { GwI18n } from "@modules/i18n/GwI18n/GwI18n";
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";

    import T from "@components/T.svelte";

    import RewardsCustomerStatusBasedContent from "../RewardsCustomerStatusBasedContent.svelte";

    export let isCustomerContent: boolean;
    export let points: number;
    export let pointsPrice: number;
    export let reward: RewardsSpendingRulesEntity["rewards"][number];
    export let amountFormatter: RewardsAmountFormatter;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let sanitizer: HTMLSanitizerInterface;
    export let i18n: GwI18n;
    export let namespace: RewardsTranslationNamespaces;
    export let pointsNamespace: RewardsTranslationNamespaces;
</script>

<RewardsCustomerStatusBasedContent {isCustomerContent}>
    <RewardsPoints
        slot="customer-content"
        {points}
        {amountFormatter}
        {i18n}
        {pointsNamespace}
    >
        <T
            let:value={{
                points,
                pointsName,
            }}
            slot="default"
            {namespace}
            translationKey="spending_rules_earn_more_to_get_discount"
            translationOptions={{
                points,
                points_name: pointsName,
            }}
        />
    </RewardsPoints>
    <RewardsSpendingRulesReward
        slot="default-content"
        {reward}
        {pointsPrice}
        {currencyFormatter}
        {amountFormatter}
        {sanitizer}
        {i18n}
        {namespace}
        {pointsNamespace}
    />
</RewardsCustomerStatusBasedContent>
